import { search } from 'search';

export const searchSettings = search;
export const DEFAULT_REPLICA = 'engagements_risk_trend_score_desc';

export const ATTRIBUTE_KEY_CALL_STATUS_ID = 'intervention_status_id';
export const ATTRIBUTE_KEY_PERIOD_ID = 'period.periodId';
export const ATTRIBUTE_KEY_RISK_LEVEL = 'risk.level';
export const ATTRIBUTE_KEY_STAFF_NAME = 'staff.name';
